var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLoadingSpinner = function SvgLoadingSpinner(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_632_21277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5 15C87.3669 15 98.9672 18.5189 108.834 25.1118C118.701 31.7047 126.391 41.0754 130.933 52.039C135.474 63.0025 136.662 75.0665 134.347 86.7054C132.032 98.3443 126.318 109.035 117.926 117.426C109.535 125.818 98.8443 131.532 87.2054 133.847C75.5665 136.162 63.5025 134.974 52.539 130.433C41.5754 125.891 32.2047 118.201 25.6118 108.334C19.0189 98.4672 15.5 86.8669 15.5 75C15.5 59.087 21.8214 43.8258 33.0736 32.5736C44.3258 21.3214 59.587 15 75.5 15V15Z",
    fill: "#F8F8FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.047 59.46C111.665 59.2137 112.223 58.8389 112.685 58.3604C113.147 57.8819 113.502 57.3107 113.727 56.6846C113.951 56.0585 114.04 55.3918 113.987 54.7288C113.934 54.0658 113.741 53.4217 113.42 52.839C109.713 46.4959 104.474 41.184 98.1831 37.3895C91.8919 33.5951 84.7494 31.4393 77.4095 31.1196C70.0695 30.7999 62.7666 32.3265 56.1694 35.5596C49.5721 38.7927 43.8912 43.629 39.6467 49.6258C35.4023 55.6226 32.7299 62.5883 31.8742 69.8851C31.0184 77.182 32.0068 84.577 34.7486 91.3931C37.4905 98.2092 41.8983 104.229 47.5686 108.9C53.2389 113.572 59.9904 116.747 67.2052 118.134C67.8613 118.243 68.5329 118.21 69.1756 118.04C69.8184 117.869 70.4175 117.563 70.9332 117.144C71.4489 116.724 71.8695 116.199 72.1671 115.604C72.4646 115.01 72.6324 114.358 72.6592 113.694C72.7023 112.318 72.2542 110.971 71.3951 109.895C70.536 108.818 69.3219 108.083 67.9702 107.82C62.578 106.584 57.5733 104.039 53.3985 100.41C49.2238 96.78 46.0076 92.1777 44.0344 87.0097C42.0611 81.8416 41.3915 76.267 42.0848 70.7787C42.7781 65.2904 44.813 60.0574 48.0094 55.5424C51.2059 51.0274 55.4655 47.3695 60.4117 44.8921C65.3579 42.4147 70.8383 41.1941 76.3684 41.3382C81.8985 41.4823 87.3079 42.9866 92.1183 45.7183C96.9288 48.4499 100.992 52.3247 103.949 57C104.648 58.1856 105.746 59.084 107.046 59.5347C108.346 59.9854 109.765 59.9589 111.047 59.46Z",
    fill: "#D5D9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8661 71.436C36.2062 71.3531 35.5362 71.4114 34.9005 71.6071C34.2649 71.8028 33.6781 72.1314 33.1791 72.5711C32.6801 73.0108 32.2803 73.5516 32.0062 74.1576C31.732 74.7635 31.5899 75.4209 31.5891 76.086C31.757 82.8739 33.4963 89.5305 36.6704 95.5329C39.8445 101.535 44.3671 106.72 49.8828 110.68C55.3985 114.64 61.7572 117.267 68.4594 118.355C75.1617 119.444 82.025 118.963 88.5102 116.952C94.9955 114.94 100.926 111.453 105.836 106.763C110.746 102.073 114.502 96.3086 116.809 89.9224C119.116 83.5363 119.911 76.7023 119.131 69.9572C118.352 63.2121 116.019 56.7396 112.316 51.048C111.939 50.5001 111.45 50.0387 110.881 49.6942C110.313 49.3497 109.677 49.13 109.017 49.0497C108.357 48.9694 107.687 49.0304 107.052 49.2285C106.418 49.4266 105.832 49.7575 105.335 50.199C104.314 51.1231 103.656 52.38 103.476 53.7452C103.297 55.1104 103.609 56.4948 104.357 57.651C106.992 62.0254 108.597 66.9416 109.051 72.0278C109.505 77.114 108.797 82.2369 106.979 87.0089C105.161 91.7809 102.282 96.0769 98.5589 99.572C94.836 103.067 90.3669 105.67 85.4898 107.183C80.6127 108.696 75.4553 109.08 70.4079 108.306C65.3604 107.532 60.5552 105.62 56.3557 102.715C52.1562 99.8094 48.6724 95.9871 46.168 91.537C43.6636 87.0868 42.2042 82.1254 41.9001 77.028C41.8629 75.6496 41.3357 74.3296 40.4131 73.3047C39.4906 72.2799 38.233 71.6174 36.8661 71.436Z",
    fill: "url(#paint0_linear_632_21277)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_632_21277",
    x: 15,
    y: 15,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_632_21277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_632_21277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_632_21277",
    x1: 111.517,
    y1: 70.1974,
    x2: 51.5825,
    y2: 104.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2366B1"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoadingSpinner.45a65667beb57ba02a7d26ba57cc9af6.svg";